module.exports = __webpack_public_path__ + "img/nabl_gallery3.fc402072.jpg";